
$(function() {

    eM.init();

    sui_sc.init();
	board_menu_hack.init();
    transManager.getTrans();

		lM.init();


	if ((eM.getUserLocaleCode() == 'ar_AE') || (eM.getLocale() == 'ar_AE')) {

    } else{
		//if((eM.getLocale() != 'tr_TR') && (eM.getPageType() == "category")){
        if( eM.getPageType() == "home" )
        {
		  ev.init();
        }
	}

	//$("#page-content").heroBanner({contentOffset: -40});


    // removed temporary
    //threadRunner.init();

    //replyRunner.init();

	connectManager.init();
	//watch_dogs.init();

    var $body = $( 'body' );

    $body.SiteCatalyst();
    $body.ContactManager();
});
/*
if(typeof(non_sony_fonts) == "undefined"){
var MTIProjectId='289bf93d-1f8b-49b5-95a2-888a76ac7e82';
 (function() {
        var mtiTracking = document.createElement('script');
        mtiTracking.type='text/javascript';
        mtiTracking.async='true';
        mtiTracking.src=('https:'==document.location.protocol?'https:':'http:')+'//fast.fonts.net/t/trackingCode.js';
        (document.getElementsByTagName('head')[0]||document.getElementsByTagName('body')[0]).appendChild( mtiTracking );
   })();
}
*/
